import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class strings safely. Used by every shadcn primitive.
 *
 * `clsx` collapses falsy/conditional inputs; `twMerge` resolves Tailwind
 * conflicts (e.g. later `p-4` overrides earlier `p-2`). The combination is
 * the standard shadcn helper.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
